<script lang="ts" setup>
import generationPPtJson from '../useTemp/index';
import {
  color,
  theme,
  step,
  showLeftTabBar,
  showLodingDialog,
  pptNode,
  slideJson
} from '../use/data';
import { goBackTotheme, goBack } from '../use/methods';
import { ref } from 'vue';
import { _createPPT } from '@/api';
import PPTStore from '@/stores/PPTStore';
import { storeToRefs } from 'pinia';

const { curentPPT } = storeToRefs(PPTStore());
const checkedTemplateIndex: Ref<number> = ref(0);

const previewList = ['catalogue', 'headline', 'thank'];
const templateList = [
  // 主题
  { status: 1, color: '#c4d9ef', theme: 'flower' },
  { status: 1, color: '#b07a58', theme: 'work' },
  { status: 1, color: '#a5b6c4', theme: 'wind' },
  { status: 1, color: '#3db3a9', theme: 'summer' },
  { status: 1, color: '#ffc000', theme: 'fall' },
  { status: 1, color: '#484850', theme: 'wave' },
  { status: 1, color: '#d3190b', theme: 'plan' },
  { status: 1, color: '#55bded', theme: 'business' },
  { status: 1, color: '#e9d8cf', theme: 'resume' },
  { status: 1, color: '#ff8181', theme: 'makeup' },
  { status: 1, color: '#0683e4', theme: 'train' },
  { status: 1, color: '#cdcbdc', theme: 'smart' },
  { status: 1, color: '#c61c2b', theme: 'policy' },
  { status: 1, color: '#7f7f7f', theme: 'simple' },
  { status: 1, color: '#8aa4b7', theme: 'mount' },
  { status: 1, color: '#969696', theme: 'sketch' },
  { status: 1, color: '#dbf5cd', theme: 'leaf' },
  { status: 1, color: '#dac0bf', theme: 'paint' },
  { status: 1, color: '#c84e5f', theme: 'company' },
  { status: 1, color: '#edc472', theme: 'newyear' }

  // { status: 1, color: '#0000FF' },
  // { status: 1, color: '#54FF9F' },
  // { status: 1, color: '#FFC125' },
  // { status: 1, color: '#FF6A6A' },
  // { status: 1, color: '#9932CC' },
  // { status: 1, color: '#00BFFF' },
  // { status: 1, color: '#00CD00' },
  // { status: 1, color: '#FFC125' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' },
  // { status: 2, color: '#696969' }
];

const checkedColor = computed(() => {
  color.value = templateList[checkedTemplateIndex.value].color;
  return templateList[checkedTemplateIndex.value].color;
});
const checkedTheme = computed(() => {
  theme.value = templateList[checkedTemplateIndex.value]?.theme;
  return templateList[checkedTemplateIndex.value].theme;
});

const checkedTemplate = (item: any, index: number) => {
  if (item.status === 2) return;
  checkedTemplateIndex.value = index;
};

const goNextStep = async () => {
  showLodingDialog.value = true;
  const json: any = await generationPPtJson(pptNode.value[0], checkedColor.value, theme.value);
  showLodingDialog.value = false;
  slideJson.value = [];
  slideJson.value.push(...json);
  curentPPT.value = null;
  step.value = 'slide-ppt';
};
</script>

<template>
  <div class="slide-ppt-template">
    <div class="slide-ppt-template-main">
      <div class="absolute" flex>
        <div class="white-button px-15 py-10 rounded-20" @click="goBackTotheme">
          <svg w-16 h-16 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path
              fill="currentColor"
              d="M512 128 128 447.936V896h255.936V640H640v256h255.936V447.936z"
            ></path>
          </svg>
          <!-- <span class="iconfont ppt-back mr-5 !text-12"></span> -->
          <span ml-4>返回首页</span>
        </div>
        <div class="white-button px-15 py-10 rounded-20 ml-10" @click="goBack">
          <span class="iconfont ppt-back mr-5 !text-12"></span>
          返回
        </div>
      </div>
      <div class="select-template-body">
        <div class="select-template-content">
          <div class="py-15 px-20 text-16 bold">选择一套模板，开始创建PPT</div>
          <div class="h-1 w-full" style="background: #eff0f1"></div>
          <div class="overflow-hidden flex">
            <div class="overflow-hidden flex-col flex-center p-20px" flex-1>
              <div flex-center flex-col gap-14px>
                <div
                  class="template-left-main"
                  :style="{
                    'background-image': checkedTheme
                      ? `url('/images/custom/${checkedTheme}/preview.png')`
                      : ''
                  }"
                ></div>
                <div w-718px flex gap-14>
                  <div
                    class="template-left-item"
                    rounded-10
                    flex-1
                    v-for="item in previewList"
                    :key="item"
                  >
                    <el-image
                      :src="`/images/custom/${checkedTheme}/pv-${item}.png`"
                      fit="cover"
                      class="w-230px h-140px"
                      rounded-10
                    >
                    </el-image>
                  </div>
                </div>
              </div>

              <div class="p-10 h-100 flex-col" v-if="!showLeftTabBar">
                <div scroll-x class="w-full scroll-x">
                  <div class="p-5 h-full">
                    <div class="template-list-mobile">
                      <div
                        v-for="(item, index) in templateList"
                        :key="index"
                        class="template-item-mobile"
                        :class="{ 'cursor-pointer': item.status == 1 }"
                        :style="{
                          '--template-color': item.color + '15',
                          '--template-color1': item.color + '75',
                          '--template-color2': item.color + '99',
                          '--template-color3': item.color + 'c7',
                          'background-image': item.theme
                            ? `url('/images/custom/${item.theme}/preview.png')`
                            : ''
                        }"
                        @click="checkedTemplate(item, index)"
                      >
                        <div class="shade" v-if="item.status == 2">敬请期待</div>
                        <div class="shade" v-if="checkedTemplateIndex == index">
                          <div class="iconfont icon-checked text-20"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="h-full w-1" style="background: #eff0f1" v-if="showLeftTabBar"></div>
            <div class="p-10 h-full flex-center flex-col w-380px" v-if="showLeftTabBar">
              <div py-16px flex-center>选择一个喜欢的主题风格，点击继续生成进入编辑模式</div>
              <div class="flex-1 p-5 full scroll">
                <div class="template-list">
                  <div
                    v-for="(item, index) in templateList"
                    :key="index"
                    class="template-item"
                    :class="{ 'cursor-pointer': item.status == 1 }"
                    :style="{
                      'background-image': item.theme
                        ? `url('/images/custom/${item.theme}/preview.png')`
                        : ''
                    }"
                    @click="checkedTemplate(item, index)"
                  >
                    <div class="shade" v-if="item.status == 2">敬请期待</div>
                    <div class="shade" v-if="checkedTemplateIndex == index">
                      <span class="iconfont ppt-icons- !text-40"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div w-full class="next-btn">
                <div class="next-step" @click="goNextStep">继续生成</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CsdDialog :showDialog="showLodingDialog">
      <div class="w-200 bg-#FFFFFF" rounded-20>
        <div class="w-full flex-center">
          <img src="/images/ppt/loading.gif" style="width: 160px; height: 160px" />
        </div>
        <div class="flex-center p-10">ppt正在生成，请稍后...</div>
      </div>
    </CsdDialog>
  </div>
</template>

<style lang="scss">
.slide-ppt-template {
  width: 100%;
  height: 100%;
  padding: 15px;
  background: linear-gradient(180deg, #e1f5ff 0%, #ffffff 27%, #ffffff 100%);
  position: relative;

  &-main {
    z-index: 2;
    position: relative;
    width: 100%;
    height: 100%;

    .select-template-body {
      color: #333;
      font-size: 14px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .select-template-content {
        // width: 750px;
        // height: 500px;
        width: 1170px;
        height: 640px;
        max-width: 100% !important;
        background-color: white;
        box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
        border: 1px solid #eff0f1;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        .template-left-main {
          width: 718px;
          height: 400px;
          border-radius: 10px;
          box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
          overflow: hidden;
          position: relative;
          background-color: var(--template-color);
          background-size: 100% auto;
          background-repeat: no-repeat;
        }
        .template-left-item {
          box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
        }

        .template-list {
          background-color: white;
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
          // width: 216px;
          width: 100%;
        }

        .template-item {
          // width: 100px;
          flex: 1 1 45%;
          // width: 45%;
          // height: 65px;
          height: 100px;
          border-radius: 4px;
          box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
          overflow: hidden;
          position: relative;
          background-color: var(--template-color);
          background-size: 100% 100%;

          .left-top-triangle {
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
            border-top: 25px solid var(--template-color3);
            border-left: 30px solid var(--template-color3);
            border-bottom: 25px solid transparent;
            border-right: 30px solid transparent;
          }

          .left-bottom-triangle {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0;
            height: 0;
            border-bottom: 17px solid var(--template-color1);
            border-left: 25px solid var(--template-color1);
            border-top: 17px solid transparent;
            border-right: 25px solid transparent;
          }

          .right-bottom-triangle {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0;
            height: 0;
            border-bottom: 15px solid var(--template-color2);
            border-right: 20px solid var(--template-color2);
            border-top: 15px solid transparent;
            border-left: 20px solid transparent;
          }

          .template-title {
            position: absolute;
            font-size: 13px;
            font-weight: bold;
            left: 40px;
            top: 15px;
          }

          .template-line {
            position: absolute;
            font-size: 13px;
            left: 40px;
            top: 32px;
            background-color: var(--template-color2);
            height: 0.5px;
            width: 60px;
          }

          .template-theme {
            position: absolute;
            font-size: 12px;
            white-space: nowrap;
            transform: scale(0.6);
            left: 20px;
            top: 30px;
          }

          .shade {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #33333399;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
            font-size: 14px;
          }
        }

        .template-list-mobile {
          background-color: white;
          display: flex;
          gap: 16px;
          flex-wrap: nowrap;

          .template-item-mobile {
            width: 100px;
            height: 65px;
            border-radius: 4px;
            box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.16);
            overflow: hidden;
            position: relative;
            background-color: var(--template-color);
            background-size: 100% 100%;
            flex-shrink: 0;

            .left-top-triangle {
              position: absolute;
              left: 0;
              top: 0;
              width: 0;
              height: 0;
              border-top: 25px solid var(--template-color3);
              border-left: 30px solid var(--template-color3);
              border-bottom: 25px solid transparent;
              border-right: 30px solid transparent;
            }

            .left-bottom-triangle {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 0;
              height: 0;
              border-bottom: 17px solid var(--template-color1);
              border-left: 25px solid var(--template-color1);
              border-top: 17px solid transparent;
              border-right: 25px solid transparent;
            }

            .right-bottom-triangle {
              position: absolute;
              right: 0;
              bottom: 0;
              width: 0;
              height: 0;
              border-bottom: 15px solid var(--template-color2);
              border-right: 20px solid var(--template-color2);
              border-top: 15px solid transparent;
              border-left: 20px solid transparent;
            }

            .template-title {
              position: absolute;
              font-size: 13px;
              font-weight: bold;
              left: 40px;
              top: 15px;
            }

            .template-line {
              position: absolute;
              font-size: 13px;
              left: 40px;
              top: 32px;
              background-color: var(--template-color2);
              height: 0.5px;
              width: 60px;
            }

            .template-theme {
              position: absolute;
              font-size: 12px;
              white-space: nowrap;
              transform: scale(0.6);
              left: 20px;
              top: 30px;
            }

            .shade {
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: #33333399;
              display: flex;
              justify-content: center;
              align-items: center;
              color: white;
              font-size: 14px;
            }
          }
        }

        .scale-4 {
          transform: scale(4);
        }

        .scale-2 {
          transform: scale(2.5);
        }
        .next-btn {
          position: relative;
          &::before {
            background: linear-gradient(
              180deg,
              hsla(0, 0%, 100%, 0),
              hsla(0, 0%, 100%, 0.05) 5.09%,
              hsla(0, 0%, 100%, 0.44) 21.79%,
              hsla(0, 0%, 100%, 0.76) 31.8%,
              #fff 44.3%,
              #fff
            );
            bottom: 0;
            content: '';
            height: 70px;
            left: 0;
            position: absolute;
            right: 0;
          }
        }

        .next-step {
          position: relative;
          height: 40px;
          // width: 200px;
          width: 100%;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          background: linear-gradient(90deg, #13dce6 0%, #528af6 100%);
          cursor: pointer;

          &:hover {
            background: linear-gradient(90deg, #13dce699 0%, #528af699 100%);
          }

          &:active {
            background: linear-gradient(90deg, #13dce6 0%, #528af6 100%);
          }
        }
      }
    }
  }
}
</style>
